module.exports = ".checkbox-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.checkbox-group > input[type='checkbox'] {\n    margin-right: 8px;\n}\n\n:host /deep/ *[input-label] {\n    cursor: pointer;\n    font-weight: 400;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/phoenix2/common/components/happy-checkbox-control/happy-checkbox-control.component.css
// module id = ./src/app/phoenix2/common/components/happy-checkbox-control/happy-checkbox-control.component.css
// module chunks = main